import { render, staticRenderFns } from "./detail-fees.vue?vue&type=template&id=74a9671b&scoped=true"
import script from "./detail-fees.vue?vue&type=script&lang=js"
export * from "./detail-fees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a9671b",
  null
  
)

export default component.exports